// extracted by mini-css-extract-plugin
module.exports = {"seller_directory":"SellerPopup_seller_directory__Z5_Uz","seller_popup":"SellerPopup_seller_popup__2krTq","seller_popup_title":"SellerPopup_seller_popup_title__2QOft"};